import React from "react";
import CustomApprovalModal from "@/shared/components/custom-modal";
import PathPickStartGuideExampleImage from "@/features/pathpick/features/start-guide/components/PathPickStartGuideExampleImage";

interface Props {
  isOpen: boolean;
  onClose: () => void;
  title: string;
  src: string;
  alt: string;
}

/**
 * 예시 이미지를 크게 보는 모달.
 *
 * 관리자 화면 캡처는 가로로 길어서 축소하면 글자가 읽히지 않는다. 그래서 폭을 넓게 잡고
 * 내부 스크롤(최대 92vh)로 좌우·상하를 훑을 수 있게 한다(전달서 §21).
 */
function PathPickStartGuideImageZoomModal({
  isOpen,
  onClose,
  title,
  src,
  alt,
}: Props) {
  return (
    <CustomApprovalModal
      isOpen={isOpen}
      onClose={onClose}
      minWidth={"min(1080px, 92vw)"}
      maxWidth={"92vw"}
      maxHeight={"92vh"}
      scrollBehavior={"inside"}
      isCentered={true}
    >
      <CustomApprovalModal.Header onClose={onClose} title={title} />
      <CustomApprovalModal.Body overflow={"auto"}>
        <PathPickStartGuideExampleImage
          src={src}
          alt={alt}
          placeholderHeight={"420px"}
        />
      </CustomApprovalModal.Body>
    </CustomApprovalModal>
  );
}

export default PathPickStartGuideImageZoomModal;
